<template>
  <button @click="toMint()" class="w-full">
    <div
      class="
        py-1.5
        md:py-3
        font-bold
        text-center text-sm
        md:text-base
        text-whitebase
        cursor-pointer
        hover:underline
      "
      style="
        width: 100%;
        text-decoration: underline;
        background: linear-gradient(315deg, #ff5585 0%, #268cff 100%);
      "
    >
      &gt;&gt; Step Into the DAO Elite: Claim Your Badge! &lt;&lt;
    </div>
  </button>
  <div class="text-whitebase home-size">
    <!-- NFT DAO -->
    <Banner></Banner>

    <div class="home-padding">
      <div
        class="
          p-2
          md:px-9 md:py-6
          mt-10
          text-whitebase
          flex
          justify-between
          rounded-2xl
        "
        style="border: 1px solid #2a2e33"
      >
        <div class="flex justify-between" v-if="isLargeScreen">
          <CustomSwitch
            @change="handleTypeChange"
            title="Type"
            :options="types"
            :selectedIndex="state.selectedType"
          />
          <CustomSwitch
            @change="handleChainChange"
            title="Blockchain"
            :options="homeChains"
            :selectedIndex="state.selectedChain"
          />
        </div>
        <div class="flex justify-between" v-if="!isLargeScreen">
          <CustomDropDown
            label="Types"
            @change="handleTypeChange"
            :options="types"
            :selectedIndex="state.selectedType"
          />
          <CustomDropDown
            label="Blockchain"
            @change="handleChainChange"
            :options="homeChains"
            :selectedIndex="state.selectedChain"
          />
        </div>

        <CustomToggle
          hasToolTip="true"
          :toolTip="`Some dao are running on multiple chains, except ${curChain} other chain data are filtered out.`"
          label="Selected Chain Only"
          :isChecked="state.filterStatus"
          @change="handleFilterChange"
        ></CustomToggle>
      </div>
    </div>

    <div class="home-padding">
      <ExploreDefiDao class="mb-6"></ExploreDefiDao>

      <!-- Base info  -->

      <!-- 这一部分仅更改接口. -->

      <div class="mb-6">
        <div
          v-if="isLargeScreen"
          class="flex flex-col md:flex-row md:space-x-6"
        >
          <MarketPlaces
            :loading="loading"
            :data="state.baseInfo.daoHistoryRank"
            :key="state.baseInfo.daoHistoryRank"
          ></MarketPlaces>
          <DaoRank :loading="loading" :data="daoRanks"></DaoRank>
        </div>
        <div v-else>
          <CustomCarousel
            :contents="[
              { component: MarketPlacesWithProps },
              {
                component: DaoRankWithProps,
              },
            ]"
          />
        </div>
      </div>

      <!-- 仅NFT DAO有这一部分 -->
      <div class="flex flex-col md:flex-row md:space-x-6 mb-6">
        <Distribution
          v-if="state.selectedType == 0"
          :loading="loading"
          :data="state.baseInfo.assetDistribution"
          :key="state.baseInfo.assetDistribution"
        ></Distribution>

        <TopFtAssets v-else></TopFtAssets>

        <ChangeAlert></ChangeAlert>
      </div>

      <!-- 这里要更改一个模块，然后调整接口 -->
      <div class="flex flex-col md:flex-row md:space-x-6 mb-6">
        <CollectedAssets v-if="state.selectedType == 0"></CollectedAssets>
        <WeeklyDao v-else></WeeklyDao>

        <TransferRecord></TransferRecord>
      </div>

      <!-- 这里需要更改接口以及top布局 -->
      <RelationBox
        class="mb-6"
        v-if="state.selectedType == 0 && curChain !== 'matic'"
      ></RelationBox>
      <div class="flex flex-wrap mb-6 gap-6">
        <div class="flex-item flex-grow h-full">
          <TopDaoGovernance
            :style="`height: ${
              isLargeScreen ? '452px' : '359px'
            }; max-height: 452px`"
          ></TopDaoGovernance>
        </div>
        <div class="flex-item flex-grow h-full">
          <TopVoters
            :style="`height: ${
              isLargeScreen ? '452px' : '359px'
            }; max-height: 452px`"
          ></TopVoters>
        </div>
      </div>

      <!-- 仅更改接口 -->
      <!-- <div class="mb-6">
        <DiamondHand></DiamondHand>
      </div> -->
      <GovernanceView></GovernanceView>
      <MintBadgeBanner />
    </div>

    <Footer></Footer>
  </div>
</template>

<script setup>
import { queryHomeDaoRank } from '@/api/common';
import Footer from '@/components/Framework/Footer.vue';
import CustomSwitch from '@/components/Inputs/Switches/CustomSwitch.vue';
import CustomCarousel from '../../components/CustomCarousel.vue';
import MintBadgeBanner from './component/MintBadgeBanner.vue';
import CustomDropDown from '@/components/Inputs/CustomDropDown.vue';
import CustomToggle from '@/components/Inputs/CustomToggle.vue';
import { useReqByBool, useUserInfo } from '@/hooks';
import { useMediaQuery } from '@vueuse/core';
import { computed, onMounted, provide, reactive, ref, watch } from 'vue';
import Banner from './Banner.vue';
import ChangeAlert from './ChangeAlert.vue';
import CollectedAssets from './CollectedAssets.vue';
import ExploreDefiDao from './component/ExploreDefiDao';
import TopDaoGovernance from './TopDaoGovernance.vue';
import TopVoters from './TopVoters.vue';
import MarketPlaces from './MarketPlaces.vue';
import DaoRank from './DaoRank.vue';
import Distribution from './Distribution.vue';
import TopFtAssets from './component/TopFtAssets.vue';
import WeeklyDao from './component/WeeklyDao.vue';
import TransferRecord from './TransferRecord.vue';
import RelationBox from './RelationBox.vue';
import GovernanceView from './GovernanceView.vue';
import { homeChains, homeTypes } from './constant';
import { notify } from '@kyvg/vue3-notification';
import { useRouter } from 'vue-router';
import { getMintBadgeNum } from '@/constants/contract';
import { contracts } from '@/constants';
import { mittWalletSelect } from '@/libs/event';
const $router = useRouter();
const userInfo = useUserInfo();

const curChain = ref('ethereum');
provide('curChain', curChain);

const types = [
  {
    label: 'NFT DAO',
    value: '0',
  },
  {
    label: 'DeFi DAO',
    value: '1',
  },
];

const isLargeScreen = useMediaQuery('(min-width: 1024px)');

const state = reactive({
  baseInfo: {},
  selectedChain: 0,
  selectedType: 0,
  filterStatus: false,
  isMinted: true,
});

provide('homeState', state);
const handleTypeChange = (index) => {
  state.selectedType = index;
};
const handleChainChange = (index) => {
  if (index == 1 && state.selectedChain != index) {
    window.gtag(
      'event',
      'home_tezos_click',
      "{'click_text':'home_tezos_click'}",
    );
  }
  state.selectedChain = index;
};
const handleFilterChange = (newValue) => {
  state.filterStatus = newValue;
};

const toMint = () => {
  if (userInfo.value.isSignedIn) {
    $router.push('/mintBadge');
  } else {
    mittWalletSelect();
  }
};

// const basicInfo = computed(() => [
//   {
//     name: 'DAOs',
//     value: state.baseInfo.daoCount,
//   },
//   {
//     name: 'Treasury',
//     value:
//       '$' + formatVal(state.baseInfo.totalValueUsd, { bit: 2, omit: true }),
//   },
//   {
//     name: 'NFTs',
//     value: localeNumber(state.baseInfo.nftCount),
//   },
//   {
//     name: 'Collections',
//     value: localeNumber(state.baseInfo.collections),
//   },
//   {
//     name: 'Creators',
//     value: localeNumber(state.baseInfo.artistCount),
//   },
// ]);

const daoRanks = computed(() => state.baseInfo.daoRank);

watch(
  () => state.selectedChain,
  (val) => {
    curChain.value =
      state.selectedChain == 0
        ? 'ethereum'
        : state.selectedChain == 1
        ? 'matic'
        : 'tezos';
  },
);

watch(
  () => userInfo.value.isSignedIn,
  (val) => {
    if (val) {
      getMintStatus();
    }
  },
);

const getMintStatus = async () => {
  try {
    const res = await getMintBadgeNum(
      contracts.mintBadge.address,
      userInfo.value.addr,
    );
    state.isMinted = Number(res.toString()) > 0;
  } catch (e) {
    console.log(e);
  }
};

const { loading, loadData } = useReqByBool(async () => {
  state.baseInfo = await queryHomeDaoRank(
    curChain.value,
    state.filterStatus,
    true,
  );
});

watch(
  () => [curChain.value, state.filterStatus],
  () => {
    loadData();
  },
);

onMounted(() => {
  loadData();
});

const MarketPlacesWithProps = {
  props: {
    loading: Boolean,
    data: Object,
    key: Number,
  },
  components: { MarketPlaces },
  // setup(props) {
  //   return () => <MarketPlaces {...props} />;
  // },
};

const DaoRankWithProps = {
  props: {
    loading: Boolean,
    data: Array,
  },
  components: { DaoRank },
  // setup(props) {
  //   return () => <DaoRank {...props} />;
  // },
};
</script>

<style scoped>
.home-size {
  font-size: 16px;
}
</style>
